export const stockOnHandImg = "general/stock-on-hand.svg";
